import AdminLayout from "../../../component/AdminLayout";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { useEffect, useState } from "react";
import { Button, Col, Form, Popconfirm, Row, Table, TableProps, Tooltip, Typography } from "antd";
import SearchBar from "../../../component/Search";
import { customSortDirections } from "../../../Utils/utils";
import AddEmployee from "../components/AddEmployee";
import ColumnCustomisation from "../components/ColumnCustomisation";
import {
  DeleteEmployeeAsset,
  GetLicenseColumns,
  GetLicensesList,
  axiosErrorMessages,
} from "../../../API/api";
import { enqueueSnackbar } from "notistack";
import EditEmployeeLicense from "../components/EditEmployeeLicense";
import { useAppRole, useUserRole } from "../../../API/RoleContext";
import { SorterResult } from "antd/es/table/interface";
import axios, { AxiosError } from "axios";

interface LicenseList {
  assetTagId: string;

  designation: string;
  deviceId: number;
  deviceType: string;
  licenseSoftwares: any[];
  otherSoftwares: any[];
  employeeAssetId: number;

  employeeName: string;
}

const License = () => {
  const userRole = useUserRole();
  const appRole = useAppRole()
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAddNewLicense, setIsAddNewLicense] = useState<boolean>(false);
  const [isColumnCustomisation, setColumnCustomisation] =
    useState<boolean>(false);
  const [newColumn, setNewColumns] = useState<any>([]);
  const [selectedColumnList, setSelectedColumnList] = useState<any>([]);
  const [licensesList, setlicensesList] = useState([]);
  const [transformedData, setTransformedData] = useState([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [openEditLicense, setOpenEditLicense] = useState<boolean>(false);
  const [sortedInfo, setSortedInfo] = useState<SorterResult<LicenseList>>({});
  const [pagesize,setPageSize] = useState<number>(50)

  const [editData, setEditData] = useState<LicenseList>({
    assetTagId: "",
    designation: "",
    deviceId: 0,
    deviceType: "",
    employeeAssetId: 0,
    employeeName: "",
    licenseSoftwares: [],
    otherSoftwares: [],
  });
  const handleSearch = (value: string) => {
    setCurrentPage(1);
    setSearchText(value);
    filterData(value);
  };
  const filterData = (searchText: string) => {
    if (!searchText) {
      setFilteredData([]);
    } else {
      const filtered = transformedData.filter((item: any) =>
        item.employeeName.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };
  const handleAddNewLicense = () => {
    setIsAddNewLicense(true);
  };
  const handleColumnCustomisation = () => {
    setColumnCustomisation(true);
  };
  const handleChange: TableProps<any>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    setSortedInfo(sorter as SorterResult<any>);
    setPageSize(pagination.pageSize ?? 50)

    setCurrentPage(pagination.current || 1);
  };
  const handleEdit = (rowData: any) => {
    setEditData(rowData);
    setOpenEditLicense(true);
  };
  const handleDelete = (rowData: any) => {
    setIsLoading(true);
    DeleteEmployeeAsset(rowData.employeeAssetId)
      .then((response: any) => {
        enqueueSnackbar("Deleted Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setIsLoading(false);
        GetLicenses();
      })
      .catch((error: any) => {
        enqueueSnackbar("Error in Deleting", {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        setIsLoading(false);
      });
  };
  useEffect(() => {
    GetLicenses();
    getSelectedColumns();
  }, []);

  useEffect(() => {
    // if (licensesList.length > 0) {
      const transformedArrayNew: any = licensesList?.map((item: any) => {
        const softwareVersions: { [key: string]: string } = {};
        item.licenseSoftwares.forEach((software: any) => {
          if(software)
          softwareVersions[software.softwareName] = software.softwareVersions
            .map(
              (version: { versionId: number; versions: string }) =>
                version.versions
            )
            .join(", ");
        });

        return {
          employeeAssetId: item.employeeAssetId,
          employeeName: item.employeeName,
          designation: item.designationName,
          deviceId: item.deviceTypeId,
          deviceType: item.deviceType,
          assetTagId: item.assetTagId,
          licenseSoftwares: item.licenseSoftwares,
          otherSoftwares: item.othersSoftwares,
          otherCount: item.othersSoftwares.length,
          other: item.othersSoftwares
            .map((version: any) => version.softwareName)
            .join(", "),
          ...softwareVersions,
        };
      });
      setTransformedData(transformedArrayNew);

    // }
  }, [licensesList]);
  const GetLicenses = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicensesList();
      const newData = response.data.map((category: any, index: number) => ({
        ...category,
        key: category.employeeAssetId,
      }));
      setlicensesList(newData);
      setIsLoading(false);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };
  const getSelectedColumns = async () => {
    try {
      setIsLoading(true);
      const response = await GetLicenseColumns();

      const transformedArray = response.data
        .sort((a: any, b: any) => a.columnId - b.columnId)
        .filter((item: any) => item.columnOrder != 0) // Filter items with columnOrder 0
        .map((item: any, index: number) => ({
          title: item.softwareName, // Convert to lowercase for consistency
          order: index,
          width:'20%',

          dataIndex: item.softwareName, // Convert to lowercase for consistency
          render: (text: string, record: any) => <Tooltip placement="topLeft" title={text}>
          <div className="truncate-text">{text}</div>
        </Tooltip>,
        }));

      setSelectedColumnList(transformedArray);
      setIsLoading(false);
    } catch (error:any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    
      setIsLoading(false);
    }
  };
  const columns = [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
      fixed:'left',
      width:'10%',
      render: (text: any, record: any, index: number) =>
        (currentPage - 1) * pagesize + index + 1,
    },
    {
      title: "Employee",
      dataIndex: "employeeName",
      key: "employeeName",
      fixed:'left',
      width:'30%',
      render: (text: string) =>  <Tooltip placement="topLeft" title={text}>
      <div className="truncate-text">{text}</div>
    </Tooltip> ,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      width:'20%',

      render: (text: string, record: any) => <div> {text}</div>,
    },
    {
      title: "Device",
      dataIndex: "deviceType",
      width:'20%',

      key: "deviceType",
      render: (text: string, record: any) =>  <Tooltip placement="topLeft" title={text}>
      <div className="truncate-text">{text}</div>
    </Tooltip>,
    },
    {
      title: "Asset ID",
      dataIndex: "assetTagId",
      key: "assetTagId",
      width:'20%',

      render: (text: string, record: any) => <Tooltip placement="topLeft" title={text}>
      <div className="truncate-text">{text}</div>
    </Tooltip>,
    },
  
    {
      title: "Other",
      dataIndex: "otherCount",
      key: "otherCount",
      width:'10%',

      render: (text: string, record: any) => (
        <Tooltip placement="topLeft" title={record.other}>
          <div>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: "OS",
      dataIndex: "OS",
      key: "OS",
      width:'10%',
      render: (text: string, record: any) =>   <Tooltip placement="topLeft" title={text}>
      <div className="truncate-text">{text}</div>
    </Tooltip>,
    },
    ...(!userRole.includes('Manager') && !userRole.includes('CEO')
    ? [
    {
      title: "Action",
      dataIndex: "action",
      width:'10%',
      render: (_: any, record: any) => {
        return (
          <>
            {" "}
            <Typography.Link onClick={() => handleEdit(record)}>
              <EditOutlined />
            </Typography.Link>
            {
              appRole === 'Admin' && <Popconfirm
              title="Do you want to delete the employee?"
              onConfirm={() => handleDelete(record)}
            >
              <Typography.Link className="delete-btn">
                <DeleteOutlined />
              </Typography.Link>
            </Popconfirm>
            }
           
          </>
        );
      },
    },
  ]
  : []),
  ];

  const closeAddPopup = () => {
    setOpenEditLicense(false)
    setIsAddNewLicense(false);
    GetLicenses();
  };
  useEffect(() => {
    // if (selectedColumnList.length > 0) {
      const newColumn = [...columns, ...selectedColumnList];
      //changing order
      const actionIndex = newColumn.findIndex(
        (item: any) => item.title === "Action"
      );

      // If 'Action' is found, remove it from the array and push it to the end
      if (actionIndex !== -1) {
        const actionItem = newColumn.splice(actionIndex, 1)[0];
        newColumn.push(actionItem);
      }

      setNewColumns(newColumn);
    // }
  }, [selectedColumnList]);

  return (
    <>
      <AdminLayout>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme: any) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div>
          <div className="employee-table-header ">
                       <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px"}}>
              <Col className="gutter-row" xl={12} lg={12} sm={24}>
                <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                  License
                </h3>
              </Col>
              <Col className="gutter-row pm-search-flex" xl={{span: 10, offset: 2}} lg={24} xs={24} style={{ display: "flex"}}>
                <SearchBar
                  width={"100%"}
                  onSearch={handleSearch}
                  placeholder={"Search Employee"}
                />
{(!userRole.includes('Manager') && !userRole.includes('CEO')) && <><Button
                  onClick={handleAddNewLicense}
                  type="primary"
                  style={{ marginLeft: 10 }}
                  size="small"
                >
                  Add New
                </Button>
                <Button
                  onClick={handleColumnCustomisation}
                  type="primary"
                  style={{ marginLeft: 10 }}
                  size="small"
                >
                  Column Customisation
                </Button></>}
                
              </Col>
            </Row>
         </div>

          <Table
            sortDirections={customSortDirections}
            className="status-list-admin"
            columns={newColumn}
            size='small'
            tableLayout='fixed'
            onChange={handleChange}
            rowClassName="editable-row"
            pagination={{
              current: currentPage,
              showSizeChanger: true,
              defaultPageSize: 50,
            }}
            dataSource={searchText ? filteredData : transformedData}
            scroll={{ x: 1500 , y: 400}} 
          />
        </div>
        {isAddNewLicense && <AddEmployee closeAddPopup={closeAddPopup} />}
        {isColumnCustomisation && (
          <ColumnCustomisation
            handleClosePopup={() =>{getSelectedColumns();setColumnCustomisation(false);GetLicenses()} }
          />
        )}
        {openEditLicense && (
          <EditEmployeeLicense
            closeAddPopup={closeAddPopup}
            editData={editData}
          />
        )}
      </AdminLayout>
    </>
  );
};

export default License;
